import { Button, Checkbox, Panel, PanelType, Stack, Toggle, getTheme, Text, Label, Link, DefaultButton, IRenderFunction, IPanelProps, Separator, useTheme } from "@fluentui/react";
import React, { useState } from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { IComment } from "../../model/FlexibleAttributeModel";
import { RootState } from "../../app/store";
import { toggleCommentStatus } from "../../global/Reducer/dataSlice";
import { RouterParams } from "../../App";
import { useHistory } from "react-router-dom";
import { updateCollapse, toggleShowTabs } from "../../global/Reducer/statusSlice";
import { fadeIn, panelButtonsStyles } from "global/Application";

interface IProps extends TComponentConnectedProps {
    isOpen?: boolean;
    dismissPanel?: ((ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => void)
    isHiddenOnDismiss?: boolean;
}

const UnderwritingCommentPanel = (props: IProps) => {
    const [showAll, setShowAll] = useState<boolean>(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const theme = useTheme();

    const linkBuilder = (location: RouterParams) => {
        // there was a bug here where the route was not being built correctly 
        // during the update configuration, the snapshot still had the old ids
        
        let route = `/records/blueRelationship/${props.state.data.account?.accountid}/groupConfiguration/${props.state.data.snapshot.bcbs_groupconfigurationsnapshotid}`;
        if (location.planId)
            route += `/plan/${location.planId}`;
        if (location.benefitId)
            route += `/benefit/${location.benefitId}`;
        if (location.claimsARId)
            route += `/claimsAR/${location.claimsARId}`;
        if (location.stopLossId)
            route += `/stopLoss/${location.stopLossId}`;
        if (location.feesAndPremiumId)
            route += `/feesAndPremium/${location.feesAndPremiumId}`;
        if (location.tabId)
            route += `/tab/${location.tabId}`;
        if (location.sectionId)
            route += `/section/${location.sectionId}`;
        if (location.fieldId)
            route += `/field/${location.fieldId}`;
        return route;
    };

    const comparisonLinkBuilder = (location: RouterParams) => {

        if (location.planId) {
            dispatch(updateCollapse({ id: `compare.plan.attributes.${location.planId}`, collapse: false }));
            dispatch(updateCollapse({ id: `compare.plan.${location.planId}`, collapse: false }));
            dispatch(updateCollapse({ id: "Plans", collapse: false }));
        }
        if (location.benefitId) {
            dispatch(updateCollapse({ id: `compare-benefit.attributes.${location.benefitId}`, collapse: false }));
            dispatch(updateCollapse({ id: `compare-benefit.${location.benefitId}`, collapse: false }));
            dispatch(updateCollapse({ id: "compare-benefits", collapse: false }));
        }

        if (location.claimsARId) {
            dispatch(updateCollapse({ id: `compare-claimsAr.${location.claimsARId}`, collapse: false }));
            dispatch(updateCollapse({ id: `compare-claimsar`, collapse: false }));
        }
        if (location.stopLossId) {
            dispatch(updateCollapse({ id: `compare-stoploss.${location.stopLossId}`, collapse: false }));
            dispatch(updateCollapse({ id: `compare-stoploss`, collapse: false }));
            dispatch(updateCollapse({ id: `groupConfiguration.stopLoss`, collapse: false }));
        }
        if (location.feesAndPremiumId) {

            dispatch(updateCollapse({ id: `compare-fp.${location.feesAndPremiumId}.attributes`, collapse: false }));
            dispatch(updateCollapse({ id: `compare-fp.${location.feesAndPremiumId}`, collapse: false }));
            dispatch(updateCollapse({ id: 'groupConfiguration.feesAndPremiums', collapse: false }));
        }
        if (!location.feesAndPremiumId && !location.stopLossId && !location.claimsARId && !location.benefitId && !location.planId)
            if (location.sectionId)
                dispatch(updateCollapse({ id: 'groupConfiguration.attributes', collapse: false }));

        if (location.tabId) {
            if (props.state.status.showTabs)
                dispatch(toggleShowTabs())
        }
        setTimeout(() => {
            let docElement: HTMLElement | null = null;

            if (location.fieldId) {
                docElement = document.getElementById(location.fieldId);
            } else if (location.sectionId) {
                docElement = document.getElementById(location.sectionId);
            }
            docElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });

        }, 1000);
        console.log(props.state.status.panelStatus);
    }

    const snap = props.state.router.location.pathname.indexOf('underwritingReview') > 0 ? props.state.comp.rightSnap : props.state.data

    const breadcrumbBuilder = (location: RouterParams) => {
        let breadcrumb = "Group Configuration";
        if (location.planId)
            breadcrumb += ` > Plan: ${snap?.json?.plans?.find(p => p.id === location.planId)?.name}`;
        if (location.benefitId)
            breadcrumb += ` > Benefit: ${snap?.json?.benefits?.find(p => p.id === location.benefitId)?.name}`;
        if (location.claimsARId)
            breadcrumb += ` > Accounts Receivable: ${snap?.json?.claimsARs?.find(p => p.id === location.claimsARId)?.name}`;
        if (location.stopLossId)
            breadcrumb += ` > Stop Loss: ${snap?.json?.stopLoss?.find(p => p.id === location.stopLossId)?.name}`;
        if (location.feesAndPremiumId)
            breadcrumb += ` > Fees and Premium: ${snap?.json?.feesAndPremiums?.find(p => p.id === location.feesAndPremiumId)?.name}`;
        if (location.tabId)
            breadcrumb += ` > Tab: ${props.state.data.config.tabs.find(p => p.bcbs_config_tabid === location.tabId)?.bcbs_name}`;
        if (location.sectionId)
            breadcrumb += ` > Section: ${props.state.data.config.sections?.find(p => p.bcbs_config_sectionid === location.sectionId)?.bcbs_name}`;
        if (location.fieldId)
            breadcrumb += ` > Field: ${props.state.data.config.attributes.find(p => p.bcbs_config_attributeid === location.fieldId)?.bcbs_name}`;
        return breadcrumb;
    }

    const isUnderWritingReview = props.state.router.location.pathname.indexOf('underwritingReview') > 0;

    const styleBox: React.CSSProperties = {
        border: '1px solid lightgray',
        boxShadow: theme.effects.elevation8,
        padding: '10px',
        backgroundColor: theme.semanticColors.menuBackground,
    };

    const onRenderComment = (eachComment: IComment, withLocation: boolean, withResolve: boolean) => {
        return <Stack.Item key={eachComment.id}>
            <div style={styleBox}>
                <Stack tokens={{ childrenGap: '15px' }}>

                    <div>
                        <Label>Comment</Label>
                        <Text>
                            {eachComment.comment}
                        </Text>
                    </div>

                    {withLocation &&
                        <div>
                            <Label>Location</Label>
                            <Text variant="small">
                                <Link
                                    onClick={() => {
                                        if (!isUnderWritingReview)
                                            history.push(linkBuilder(eachComment.location));

                                        if (isUnderWritingReview)
                                            comparisonLinkBuilder(eachComment.location)
                                    }}
                                >
                                    {breadcrumbBuilder(eachComment.location)}
                                </Link>
                            </Text>
                        </div>
                    }
                    {withResolve &&
                        <Checkbox
                            label="Resolved"
                            checked={eachComment.status === 2}
                            onChange={() => dispatch(toggleCommentStatus(eachComment))}
                        />
                    }
                </Stack>
            </div>
        </Stack.Item>
    }

    const onRenderBody = () => {

        const commentsGroupConfig: IComment[] = [];
        const commentsEntities: IComment[] = [];

        snap.json?.comments.forEach((eachComment: IComment) => {

            if (eachComment.id === props.state.data.json.id)
                commentsGroupConfig.push(eachComment);
            else if (showAll || eachComment.status === 1)
                commentsEntities.push(eachComment);

        });

        return <div className={fadeIn}>
            <Separator />

            <Stack tokens={{ childrenGap: '10px' }}>
                <Toggle
                    label="Show only unresolved comments"
                    checked={!showAll}
                    inlineLabel
                    onChange={() => setShowAll(!showAll)}
                />

                {commentsGroupConfig.length > 0 &&
                    <Stack tokens={{ childrenGap: '15px' }}>
                        <Text variant="mediumPlus">Overall Comments:</Text>
                        {commentsGroupConfig.map((eachComment: IComment) => (
                            onRenderComment(eachComment, false, false)
                        ))}
                    </Stack>
                }

                {commentsGroupConfig.length > 0 &&
                    <Separator styles={{ root: { padding: '0' } }} />
                }

                {commentsEntities.length > 0 &&
                    <Stack tokens={{ childrenGap: '15px' }}>
                        <Text variant="mediumPlus">Area Comments:</Text>
                        {commentsEntities.map((eachComment: IComment) => (
                            onRenderComment(eachComment, true, true)
                        ))}
                    </Stack>
                }

            </Stack>
        </div>
    }

    const onRenderFooterContent: IRenderFunction<IPanelProps> = (contextProps, defaultRender) => {
        return <div className={fadeIn}>
            <DefaultButton text='Cancel'
                styles={panelButtonsStyles}
                onClick={() => {
                    props.dismissPanel?.();
                }}
            />
        </div>;
    }

    return (
        <Panel
            isOpen={props.isOpen}
            onDismiss={props.dismissPanel}
            type={PanelType.medium}
            closeButtonAriaLabel="Close"
            headerText="Revisions Requested"
            isHiddenOnDismiss={props.isHiddenOnDismiss}
            onRenderFooterContent={onRenderFooterContent}
            isFooterAtBottom={true}
        >
            {onRenderBody()}
        </Panel>
    );
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connect(mapStateToProps)(UnderwritingCommentPanel)
